export default __webpack_public_path__ + "static/media/Crypto portfolio-amico.3024f135.svg";